import React from 'react'
import AccountTypePage from './AccountTypePage'

export default function ProAccount() {
  return (
    <AccountTypePage
      name="PRO"
      tagline="Our highest tier — priority execution and the tightest spreads for serious volume."
      description={[
        'The PRO account is designed for high-volume traders who want the tightest available spreads, commission-free pricing, and priority order routing.',
        'Combined with the Arbitrade Bot\'s highest subscription tier, PRO account holders get priority execution across both manual and automated trading.',
      ]}
      spec={[
        { label: 'Asset Classes', value: 'Forex, Metals, Energies, Indices, Crypto' },
        { label: 'Spreads From', value: '0.0 pips' },
        { label: 'Commission', value: 'None' },
        { label: 'Leverage up to', value: '1:1000' },
        { label: 'Minimum Deposit', value: '$5,000' },
        { label: 'Minimum Trade Size', value: '0.01 lots' },
        { label: 'Maximum Total Trade Size', value: 'Unlimited' },
        { label: 'Maximum Single Order Size', value: '50 lots' },
        { label: 'Account Currency', value: 'USD, USDT' },
        { label: 'Order Execution', value: 'Market' },
        { label: 'Margin Call', value: '50%' },
        { label: 'Stop Out', value: '30%' },
        { label: 'Negative Balance Protection', value: 'Yes' },
      ]}
      switchTo={[
        { label: 'STD', to: '/trading/std-account' },
        { label: 'ECN', to: '/trading/ecn-account' },
      ]}
    />
  )
}
